export const ImageResourcesUtil = {
  UNCHECKED_CHECKBOX: "unchecked_checkbox",
  CHECKED_CHECKBOX: "checked_checkbox",
  UNCHECKED_RADIO: "unchecked_radio",
  CHECKED_RADIO: "checked_radio",
  DROPDOWN: "dropdown",
  PULL_UP: "pull_up",
  CANCEL_RED: "cancel_red",
  NEXT_TASK: "next_task",
  PROFESSIONAL: "professional",
  COMPLETED_TASK: "completed_task",
  BANK: "bank",
  CHEQUE: "cheque",
  MENU_VERTICAL: "menu_vertical",
  CONTACT_SUPPORT: "contact_support",
  CAMERA_ADD: "camera_add",
  ADD_BLACK: "add_black",
  TICK_GREEN: "tick_green",
  NOT_APPROVED: "not_approved",
  APPLY_LOAN: "apply_loan",
  GALLERY_ATTACH: "gallery_attach",
  GREEN_CHECK_BORDER: "green_check_border",
  PERSON: "person",
  CALL: "call",
  WARNING_RED: "warning_red",
  REFRESH_BLUE: "refresh_blue",
  EZCRED_COLOR_LOGO_WITH_NAME: "ezcred_color_logo_with_name",
  EZCRED_LOGO_WHITE: "ezcred_logo_white",
  FILE_DOWNLOAD: "file_download",
  DELETE: "delete",
  UPLOAD: "upload",
  PASSWORD: "password",
  PAN_TEMPLATE : "pan_template",

  getImageLink: key => imageLink[key]
};

const imageLink = {
  unchecked_checkbox: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/unchecked-checkbox-72.png",
  checked_checkbox: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/checked-checkbox-72.png",
  unchecked_radio: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/unchecked-radio.png",
  checked_radio: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/checked-radio.png",
  dropdown: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/drop-down.png",
  pull_up: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/pull-up.png",
  cancel_red: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/cancel_red.png",
  next_task: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/next_actoin.png",
  completed_task: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/completed_task.png",
  professional: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/profession.png",
  bank: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/bank_logo.png",
  cheque: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/cheque.png",
  menu_vertical: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/menu_vertical.png",
  contact_support: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/contact_support.png",
  camera_add: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/camera_add.png",
  add_black: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/add_black.png",
  tick_green: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/tick_greenn.png",
  not_approved: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/not_approved.png",
  apply_loan: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/apply_loan.png",
  gallery_attach: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/gallery_attach.png",
  green_check_border: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/green_check_border.png",
  person: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/person_icon.png",
  call: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/call_icon.png",
  warning_red: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/warning_red.png",
  refresh_blue: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/refresh_blue.svg",
  ezcred_color_logo_with_name: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/ezcred_color_logo_with_name.png",
  ezcred_logo_white: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/ezcred_logo_white.png",
  file_download: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/file_download.png",
  delete: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/delete.png",
  upload: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/upload.png",
  password: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/password.png",
  //TODO Add actual PAN S3 image link
  pan_template: "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/upload.png"
};

export const DefaultResourceConfig = {
  DROP_DOWN: {
    dropDownIcon: ImageResourcesUtil.getImageLink(ImageResourcesUtil.DROPDOWN),
    pullUpIcon: ImageResourcesUtil.getImageLink(ImageResourcesUtil.PULL_UP),
    selectedItemStyle: { 'color': '#000000', 'font-weight': 'bolder' },
    disabledItemStyle: { 'color': '#808080' },
    titleStyle: { 'color': '#808080', 'font-weight': 'bolder', 'font-size': '18px' },
    radioItemStyle: { 'margin-top': '10px', 'padding-top': '10px', 'padding-bottom': '10px' },
    cellStyle: { 'padding-bottom': '20px' },
  },
  CHECK_BOX: {
    checkedIcon: ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_CHECKBOX),
    unCheckedIcon: ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_CHECKBOX),
    iconStyle: { width: "24px", height: "24px" },
    textStyle: { width: "100%", "margin-left": "5px", color: "black", "font-size": "14px" }
  },
  RADIO_BUTTON: {
    checkedColor: "#0F8DE8",
    checkedIcon: ImageResourcesUtil.getImageLink(ImageResourcesUtil.CHECKED_RADIO),
    unCheckedIcon: ImageResourcesUtil.getImageLink(ImageResourcesUtil.UNCHECKED_RADIO),
    hasVerticalIndent: false,
    radioItemStyle: { "padding-top": "5px", "padding-bottom": "5px" },
    radioLabelStyle: { color: "gray", "font-weight": "bolder", "font-size": "18px" },
    radioTextStyle: { color: "black", "font-weight": "bolder" }
  }
};

